import { gql } from 'apollo-angular';

export const GET_REPORTS = gql`
  query ($criteria: DashboardUrlsV2Criteria!) {
    dashboardUrlsV2(criteria: $criteria) {
      tenantId
      type
      url
      expiresAt
    }
  }
`;

export const DEBT_AGING_DASHBOARD = gql`
  query ($criteria: DebtAgingDashboardCriteria!) {
    debtAgingDashboard(criteria: $criteria) {
      url
    }
  }
`;

export const SEARCH_PHONE_CALL_AGENTS = gql`
  query ($criteria: SearchPhoneCallAgentsCriteria!) {
    phoneCallAgents(criteria: $criteria) {
      id
      tenantId
      externalId
      name
      provider
      config
      promptUrl
      context
    }
  }
`;

export const OUTBOUND_CALLS_DASHBOARD = gql`
  query ($criteria: OutboundCallsDashboardCriteria!) {
    outboundCallsDashboard(criteria: $criteria) {
      url
    }
  }
`;
